export default __webpack_public_path__ + "static/media/Hospitality5.682a94f8.jpg";